// assets/width-no-fade.js
(function () {
  function handleize(str) {
    return (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getProductJSON(root) {
    const el = root.querySelector("[data-product-json]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function findWidthOptionPosition(productJson) {
    if (!productJson || !Array.isArray(productJson.options)) return null;

    for (let i = 0; i < productJson.options.length; i++) {
      const name = productJson.options[i];
      const h = handleize(name);
      if (h === "width" || h.includes("width")) return i + 1; // 1-based
    }
    return null;
  }

  function initForRoot(root) {
    const productJson = getProductJSON(root);
    const widthPos = findWidthOptionPosition(productJson);
    if (!widthPos) return;

    const widthSelector = `[data-single-option-selector][data-index="option${widthPos}"]`;

    let isApplying = false;
    let rafQueued = false;

    // Clears all common "faded/disabled" states Broadcast can apply
    function clearDisabledState(input) {
      // Input-level
      input.disabled = false;
      input.classList.remove(
        "unavailable",
        "soldout",
        "disabled",
        "is-disabled",
        "is-unavailable",
        "is-soldout"
      );
      input.removeAttribute("disabled");
      input.removeAttribute("aria-disabled");

      // Label-level
      const label = root.querySelector(`label[for="${input.id}"]`);
      if (label) {
        label.classList.remove(
          "unavailable",
          "soldout",
          "disabled",
          "is-disabled",
          "is-unavailable",
          "is-soldout"
        );
        label.setAttribute("aria-disabled", "false");
        label.removeAttribute("disabled");
      }

      // Wrapper-level (Broadcast often fades via wrapper class)
      const wrapper = input.closest(".radio__button");
      if (wrapper) {
        wrapper.classList.remove(
          "unavailable",
          "soldout",
          "disabled",
          "is-disabled",
          "is-unavailable",
          "is-soldout"
        );
        // If any inline style got applied, wipe only the usual suspects
        wrapper.style.opacity = "";
        wrapper.style.pointerEvents = "";
        wrapper.style.filter = "";
      }
    }

    function unFadeWidth() {
      if (isApplying) return;
      isApplying = true;

      try {
        const widthInputs = root.querySelectorAll(widthSelector);
        if (!widthInputs.length) return;

        widthInputs.forEach((input) => clearDisabledState(input));
      } finally {
        isApplying = false;
      }
    }

    function scheduleUnfade() {
      if (rafQueued) return;
      rafQueued = true;

      requestAnimationFrame(() => {
        rafQueued = false;
        unFadeWidth();

        // Broadcast sometimes re-applies state *after* it updates the variant,
        // so we hit it a few more times quickly (cheap + safe)
        setTimeout(unFadeWidth, 25);
        setTimeout(unFadeWidth, 80);
        setTimeout(unFadeWidth, 180);
      });
    }

    // Initial
    scheduleUnfade();
    setTimeout(scheduleUnfade, 250);

    // Any selector change (size, width, etc.)
    root.addEventListener(
      "change",
      function (e) {
        const t = e.target;
        if (!t || !t.matches) return;
        if (!t.matches("[data-single-option-selector]")) return;
        scheduleUnfade();
      },
      true
    );

    // Mutation observer (guarded so we don't loop)
    const mo = new MutationObserver(() => {
      if (isApplying) return;
      scheduleUnfade();
    });

    mo.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "disabled", "aria-disabled", "style"],
    });
  }

  function boot() {
    const roots = document.querySelectorAll('[data-section-type="product"]');
    if (!roots.length) return;
    roots.forEach(initForRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();